/* __next_internal_client_entry_do_not_use__ Filter auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import React from "react";
import { createSVGIcon } from "../util";
/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1544))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.822Z
 */ export var Filter = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("line", {
            x1: "6",
            y1: "7.5",
            x2: "18",
            y2: "7.5",
            stroke: "currentColor"
        }),
        /*#__PURE__*/ _jsx("line", {
            x1: "6",
            y1: "16.5",
            x2: "18",
            y2: "16.5",
            stroke: "currentColor"
        }),
        /*#__PURE__*/ _jsx("line", {
            x1: "9.5",
            y1: "19",
            x2: "9.5",
            y2: "14",
            stroke: "currentColor"
        }),
        /*#__PURE__*/ _jsx("line", {
            x1: "14.5",
            y1: "10",
            x2: "14.5",
            y2: "5",
            stroke: "currentColor"
        })
    ]
}), "Filter", function(strictLocalize) {
    return {
        viewBox: "0 0 24 24",
        titleAccess: strictLocalize({
            id: "zjw4qG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Filter"
                }
            ]
        }),
        fill: "none",
        color: Core.icon.default
    };
});
